/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mode: NonNullable<unknown> }} Task_Settings_Assignment_ModeInputs */

const en_task_settings_assignment_mode = /** @type {(inputs: Task_Settings_Assignment_ModeInputs) => LocalizedString} */ (i) => {
	if (i?.mode === "unassigned") return /** @type {LocalizedString} */ (`Unassigned`);
	if (i?.mode === "user") return /** @type {LocalizedString} */ (`Specific person`);
	if (i?.mode === "previous_assignee") return /** @type {LocalizedString} */ (`Previous assignee`);
	if (i?.mode === "source_creator") return /** @type {LocalizedString} */ (`DVC search requester`);
	return /** @type {LocalizedString} */ (`${i?.mode}`)
	
};

const pt_br2_task_settings_assignment_mode = /** @type {(inputs: Task_Settings_Assignment_ModeInputs) => LocalizedString} */ (i) => {
	if (i?.mode === "unassigned") return /** @type {LocalizedString} */ (`Sem responsável`);
	if (i?.mode === "user") return /** @type {LocalizedString} */ (`Pessoa específica`);
	if (i?.mode === "previous_assignee") return /** @type {LocalizedString} */ (`Responsável anterior`);
	if (i?.mode === "source_creator") return /** @type {LocalizedString} */ (`Quem pediu a busca de DVC`);
	return /** @type {LocalizedString} */ (`${i?.mode}`)
	
};

/**
* | mode | output |
* | --- | --- |
* | "unassigned" | "Unassigned" |
* | "user" | "Specific person" |
* | "previous_assignee" | "Previous assignee" |
* | "source_creator" | "DVC search requester" |
* | * | "{mode}" |
*
* @param {Task_Settings_Assignment_ModeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_assignment_mode = /** @type {((inputs: Task_Settings_Assignment_ModeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Assignment_ModeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_assignment_mode(inputs)
	return pt_br2_task_settings_assignment_mode(inputs)
});